import React from "react";
import './summerschool_estero.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { isMobileOnly } from "react-device-detect";
import {insertHtml} from "../../utils/dom";

class SummerschoolEstero extends TemplateComponent {
    componentRender(data) {
        return (
            <div className="c4-summerschool-estero">
                <div className="container-fluid">
                    <div className="row">
                        <div className={!isMobileOnly ? 'img-container-' + data.content_side.toLowerCase() : 'img-container-mob'}>
                            <div className="mob-shadow" />
                            <img src={data.bgr_image} alt="Luiss.it" className="summerschool-image" />
                        </div>
                        <div className={!isMobileOnly ? 'col-4 text-container-' + data.content_side.toLowerCase() : 'text-container-mob'}>
                            <div className={!isMobileOnly ? 'text-title' : 'text-title-mob'}>{data.title}</div>
                            <div className={!isMobileOnly ? 'text-subtitle' : 'text-subtitle-mob'} {...insertHtml(data.subtitle)} />
                            <a href={data.btn_link} className="button-link"><button className={!isMobileOnly ? 'text-btn' : 'text-btn-mob'}>{data.btn_title}</button></a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SummerschoolEstero;
